import React, { useState, useEffect, useRef } from 'react';
import './Navbar.scss';
import LogoM from '../../assets/LogoM.png';
import HamburgerIcon from '../../assets/HamburgerIcon.png';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(prev => !prev);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const handleLinkClick = () => {
    setMenuOpen(false);
  };

  return (
    <nav className='navbar-container'>
      <div className='logo-title-container'>
        <div className='logoContainer'>
          <img src={LogoM} alt="logo" />
        </div>
        <div className='title'>
          MyPDF.club
        </div>
      </div>
      <div className='options-container'>
        <div role="button" tabIndex={0} className='option-item'>
          <Link to="/" className="nav-link">Home</Link>
        </div>
        <div role="button" tabIndex={0} className='option-item'>
          <Link to="/tools" className="nav-link">Tools</Link>
        </div>
        <div role="button" tabIndex={0} className='option-item'>
          <Link to="/pricing" className="nav-link">Pricing</Link>
        </div>
        <div role="button" tabIndex={0} className='option-item'>
          <Link to="/blog" className="nav-link">Blog</Link>
        </div>
        <div className='option-item-download'>
          Download Now
        </div>
      </div>

      <div role="button" tabIndex={0} className='hamburger-menu' onClick={toggleMenu}>
        <img src={HamburgerIcon} alt="Menu" />
      </div>

      {menuOpen && (
        <div className="mobile-dropdown">
          <div role="button" tabIndex={0} className='mobile-option' onClick={handleLinkClick}>
            <Link to="/" className="nav-link">Home</Link>
          </div>
          <div role="button" tabIndex={0} className='mobile-option' onClick={handleLinkClick}>
            <Link to="/tools" className="nav-link">Tools</Link>
          </div>
          <div role="button" tabIndex={0} className='mobile-option' onClick={handleLinkClick}>
            <Link to="/pricing" className="nav-link">Pricing</Link>
          </div>
          <div role="button" tabIndex={0} className='mobile-option' onClick={handleLinkClick}>
            <Link to="/blog" className="nav-link">Blog</Link>
          </div>
          <div role="button" tabIndex={0} className='mobile-option download' onClick={handleLinkClick}>Download Now</div>
        </div>
      )}
    </nav>
  )
}
